<template>
  <div>
    <v-container fluid>
      <v-card>
        <v-row>
          <v-col cols="12" md="6" lg="6" sm="6" xs="12">
            <v-card-title class="headline">
              Product Retail Margin
            </v-card-title>
          </v-col>
          <v-col cols="12" md="6" lg="6" sm="12" xs="12">
            <v-card-actions class="d-flex justify-end">
              <v-btn class="mr-2" small dense color="accent"
                :to="{ name: 'approvedProductRetailerMarginList', params: { current: 1 } }"
                title="Approved Product Retailer Margin">
                <v-icon left small>mdi-thumb-up</v-icon> Approved Product
              </v-btn>
              <v-btn v-if="modules.isUploadCsvAccess" small dense color="accent" :to="{ name: 'uploadProduct' }" title="Upload Product in CSV">
                <v-icon left>mdi-plus</v-icon> Upload CSV
              </v-btn>
            </v-card-actions>
          </v-col>
          <v-col class="py-0" cols="12" md="12" lg="12" sm="12">
            <v-card-text class="mb-0 mt-1 py-0">
              <form @submit.prevent="getUniqueRefrenceProductListOnFilterBasis">
                <v-row>
                  <v-col cols="12" md="3" lg="3" sm="4" xs="12">
                    <label class="font-weight-medium body-2">
                      Created By
                    </label>
                    <v-autocomplete :items="createdByArray" v-model="selectedCreatedby" placeholder="Select Created By"
                      hide-details />
                  </v-col>
                  <v-col cols="12" md="3" lg="3" sm="4" xs="12">
                    <label class="font-weight-medium body-2">
                      Status
                    </label>
                    <v-autocomplete clearable :items="statusArray" v-model="selectedStatus" placeholder="select All" multiple
                      hide-details />
                  </v-col>
                  <v-col cols="12" md="3" lg="3" sm="4" xs="12">
                    <label class="font-weight-medium body-2">
                      Created At
                    </label>
                    <v-menu ref="createdAt" v-model="createdAtDatePickerMenu" :close-on-content-click="false"
                      transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="createdAtFilter" placeholder="Select Created At"
                          prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="createdAtFilter" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="createdAtDatePickerMenu = false">
                          Cancel
                        </v-btn>
                        <v-btn text color="primary" @click="$refs.createdAt.save(createdAtFilter)">
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col v-if="!$vuetify.breakpoint.xs" cols="12" md="3" lg="3" sm="12">
                    <v-card-actions class="justify-center">
                      <v-btn color="#5d58ef" class="white--text" small dense type="submit">
                        <v-icon left>mdi-filter</v-icon>Apply
                      </v-btn>
                      <v-btn @click="resetApplyFilter" depressed dense small>
                        <v-icon left> mdi-restart</v-icon> Reset
                      </v-btn>
                    </v-card-actions>
                  </v-col>
                  <v-col v-else cols="12" xs="12" class="px-0">
                    <v-row no-gutters>
                      <v-col class="mb-2" cols="12" xs="12">
                        <v-btn color="#5d58ef" class="white--text" dense style="min-width: 100%" type="submit">
                          <v-icon left>mdi-filter</v-icon>Apply
                        </v-btn>
                      </v-col>
                      <v-col cols="12" xs="12">
                        <v-btn depressed dense style="min-width: 100%" @click="resetApplyFilter">
                          <v-icon left> mdi-restart</v-icon> Reset
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </form>
            </v-card-text>
          </v-col>
          <v-col class="py-0" cols="12" md="12" lg="12" sm="12" xs=12>
            <v-card-text class="my-0 py-0">
              <v-row no-gutters>
                <v-col cols="12" md="3" lg="3" sm="4" xs="12" offset-md="9" offset-lg="9" offset-sm="8">
                  <v-text-field :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
                    v-model="search" append-icon="mdi-magnify" class="ml-auto mb-2" label="Search" hide-details
                    single-line />
                </v-col>
              </v-row>
              <v-data-table :headers="headers" :items="refrenceProductData" :search="search">
                <template v-slot:item.actions="{ item }">
                  <v-btn class="px-2 ml-1 ma-1" icon color="accent" @click="getPendingProductList(item.refrenceID)" dense
                    small>
                    <v-icon small> mdi-eye</v-icon>
                  </v-btn>
                </template>
                <template v-slot:no-data>
                  <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
                </template>
              </v-data-table>
            </v-card-text>
          </v-col>
        </v-row>
      </v-card>
      <v-card-component>
        <v-card-text class="pt-0 pr-1" :class="{
          'd-block py-3': $vuetify.breakpoint.xs,
          'd-flex align-center': $vuetify.breakpoint.smAndUp
        }">
          <v-dialog fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            v-model="dialog"
          >
            <v-card>
              <v-toolbar dense class="elevation-0 white--text" color="accent">
                <v-card-title> <span class="headline">Pending Product Retailer Margin</span>
                </v-card-title>
                <v-btn class="mr-2 mt-n1" color="white" small dense icon absolute top right @click="; (dialog = false)">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container>
                  <form @submit.prevent="changeStatus">
                    <v-row>
                      <v-col cols="12">
                        <v-row no-gutters>
                          <v-col cols="12" md="12" lg="12" sm="12" xs="12">
                            <v-col cols="12" md="4" lg="4" sm="4" xs="12" offset-md="8" offset-lg="8" offset-sm="8">
                              <v-text-field
                                :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
                                v-model="productSearch" append-icon="mdi-magnify" class="ml-auto mb-2" label="Search"
                                hide-details single-line />
                            </v-col>
                          </v-col>
                        </v-row>
                        <v-data-table
                          :headers="pendingProductDataTable"
                          :items="pendingProductList"
                          hide-default-header
                          :custom-sort="customSort"
                          :search="productSearch"
                          hide-default-footer
                          disable-pagination
                        >
                          <template v-slot:header="{ props }">
                            <thead>
                              <tr>
                                <th class="text-center sortable" v-for="(item, index) in props.headers"
                                  :key="`${index}_pending_prod`" @click="sortByCustomHeader(item.value)">
                                  <div class="d-flex justify-start" v-if="item.value === 'approveAction'">
                                    <span class="align-self-center">{{ item.text }}</span>
                                    <v-checkbox small dense v-model="approveHeaderFlag" hide-details color="white"
                                      class="mt-n1 ml-3" />
                                  </div>
                                  <div class="d-flex justify-start" v-else-if="item.value === 'rejectAction'">
                                    <span class="align-self-center">{{ item.text }}</span>
                                    <v-checkbox small dense v-model="rejectHeaderFlag" hide-details color="white"
                                      class="mt-n1 ml-3" />
                                  </div>
                                  <div class="custom-header-wrapper d-flex justify-start" v-else>
                                    {{ item.text }}
                                    <span class="custom-arrow-icon" v-if="item.sortable">
                                      <v-icon class="ml-2" small v-if="isSortedBy(item.value)">mdi-arrow-up</v-icon>
                                      <v-icon class="ml-2" small v-else>mdi-arrow-down</v-icon>
                                    </span>
                                  </div>
                                </th>
                              </tr>
                            </thead>
                          </template>
                          <template v-slot:item.approveAction="{ item }">
                            <v-checkbox small dense v-model="item.approve"
                              :disabled="item.status === 'APPROVED' || item.status === 'REJECTED'"
                              @change="selectSingleCheckBox('approve', item.id, item.approve)" />
                          </template>
                          <template v-slot:item.rejectAction="{ item }">
                            <v-checkbox small dense v-model="item.reject"
                              :disabled="item.status === 'APPROVED' || item.status === 'REJECTED'"
                              @change="selectSingleCheckBox('reject', item.id, item.reject)" />
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                    <v-row v-if="modules.isCheckerAccess">
                      <v-col cols="12" class="d-flex justify-end">
                        <v-btn :disabled="isSaveDiabled" elevation="1" color="accent" type="submit">
                          <v-icon left>mdi-checkbox-marked-circle</v-icon>Save
                        </v-btn>
                      </v-col>
                    </v-row>
                  </form>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-card-text>
      </v-card-component>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>
<script>
import Utils from '@/utils'
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
export default {
  name: 'productsRetailerMargin',
  components: {
    VCardComponent
  },
  data () {
    return {
      modules: {
        isUploadCsvAccess: this.checkModuleAccess('UploadCsvData'),
        isCheckerAccess: this.checkModuleAccess('isCheckerAccess')
      },
      search: '',
      productSearch: '',
      isLoading: false,
      loadingComponent: null,
      productList: [],
      total: 0,
      data: [],
      headers: [
        { text: 'Refrence ID', value: 'refrenceID', sortable: true, align: 'center' },
        { text: 'Created Date', value: 'createdDate', sortable: true, align: 'center' },
        { text: 'Created By', value: 'createdBy', sortable: true, align: 'center' },
        { text: 'Status', value: 'status', sortable: true, align: 'center' },
        { text: 'View', value: 'actions', sortable: false, align: 'center' }
      ],
      dialog: false,
      pendingProductDataTable: [
        { text: 'Product ID', value: 'productID', sortable: true, align: 'center' },
        { text: 'MRP', value: 'product.mrp', align: 'center' },
        { text: 'Discount To Parent', value: 'discountToParent', sortable: true, align: 'center' },
        { text: 'Retailer Margin', value: 'retailerMargin', sortable: true, align: 'center' },
        { text: 'Status', value: 'status', sortable: true, align: 'center' }
      ],
      pendingProductList: [],
      approveSelected: [],
      rejectedSelected: [],
      refrenceProductData: [],
      approveHeaderFlag: false,
      rejectHeaderFlag: false,
      approveArray: [],
      rejectArray: [],
      selectedCreatedby: '',
      selectedStatus: [],
      createdAtDatePickerMenu: false,
      createdAtFilter: '',
      statusArray: constants.PRODUCT_RETAILER_MARGIN_STATUS,
      createdByArray: [],
      sortBy: '',
      sortDesc: false,
      isSaveDiabled: true,
      approveFlag: true,
      rejectFlag: false,
      refrenceID: ''
    }
  },
  async created () {
    await this.getProductList()
    if (this.modules.isCheckerAccess) {
      this.pendingProductDataTable.push(
        { text: 'Approve', type: 'approve', value: 'approveAction', align: 'center' },
        { text: 'Reject', type: 'reject', value: 'rejectAction', align: 'center' }
      )
    }
  },
  watch: {
    approveArray: function (newVal) {
      if (newVal.length > 0) {
        this.isSaveDiabled = false
      } else if (this.rejectArray.length > 0) {
        this.isSaveDiabled = false
      } else {
        this.isSaveDiabled = true
      }
    },
    rejectArray: function (newVal) {
      if (newVal.length > 0) {
        this.isSaveDiabled = false
      } else if (this.approveArray.length > 0) {
        this.isSaveDiabled = false
      } else {
        this.isSaveDiabled = true
      }
    },
    approveHeaderFlag: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal === true) {
          this.selectAllCheckBox('approve')
        } else {
          if (this.approveFlag) {
            this.pendingProductList.forEach(item => {
              if (this.approveArray.indexOf(item.id) > -1) {
                item.approve = false
              }
            })
            this.approveArray = []
          }
        }
      }
    },
    rejectHeaderFlag: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal) {
          this.selectAllCheckBox('reject')
        } else {
          if (this.rejectFlag) {
            this.pendingProductList.forEach(item => {
              if (this.rejectArray.indexOf(item.id) > -1) {
                item.reject = false
              }
            })
            this.rejectArray = []
          }
        }
      }
    }
  },
  methods: {
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    customSort (items, sortBy, sortDesc) {
      return items.sort((a, b) => {
        const sortValueA = a[sortBy]
        const sortValueB = b[sortBy]
        if (sortValueA < sortValueB) return sortDesc ? 1 : -1
        if (sortValueA > sortValueB) return sortDesc ? -1 : 1
        return 0
      })
    },
    sortByCustomHeader (headerValue) {
      if (this.sortBy === headerValue) {
        this.sortDesc = !this.sortDesc
      } else {
        this.sortBy = headerValue
        this.sortDesc = false
      }
      this.customSortData()
    },
    customSortData () {
      const sortedItems = this.customSort([...this.pendingProductList], this.sortBy, this.sortDesc)
      this.pendingProductList = sortedItems
    },
    isSortedBy (itemValue) {
      return this.sortBy === itemValue
    },
    selectAllCheckBox: function (type) {
      this.approveFlag = true
      this.rejectFlag = true
      if (type === 'approve') {
        this.rejectHeaderFlag = false
      } else {
        this.approveHeaderFlag = false
      }
      this.pendingProductList.forEach(item => {
        if (item.status === 'PENDING') {
          if (type === 'approve') {
            item.approve = true
            this.approveArray.push(item.id)
            if (this.rejectArray.indexOf(item.id) > -1) {
              this.rejectArray.splice(this.rejectArray.indexOf(item.id), 1)
              this.setApproveRejectCheckBoxFlag(type, item.id)
            }
          } else {
            item.reject = true
            this.rejectArray.push(item.id)
            if (this.approveArray.indexOf(item.id) > -1) {
              this.approveArray.splice(this.approveArray.indexOf(item.id), 1)
              this.setApproveRejectCheckBoxFlag(type, item.id)
            }
          }
        }
      })
    },
    setApproveRejectCheckBoxFlag: function (type, id) {
      this.pendingProductList.forEach(item => {
        if (item.id === id && type === 'approve') {
          item.reject = false
        } else if (item.id === id && type === 'reject') {
          item.approve = false
        }
      })
    },
    getProductList: async function () {
      try {
        const response = await http.get(
          `${constants.API_URL}/api/product/list-of-product-retailer-margin`
        )
        this.refrenceProductData = response.data
        this.refrenceProductData.forEach(item => {
          if (this.createdByArray.indexOf(item.createdBy) === -1) {
            this.createdByArray.push(item.createdBy)
          }
        })
        this.isLoading = false
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getPendingProductList: async function (refID) {
      try {
        this.refrenceID = refID
        this.approveHeaderFlag = false
        this.rejectHeaderFlag = false
        this.approveArray = []
        this.rejectArray = []
        this.dialog = true
        let obj = {
          refrenceID: this.refrenceID
        }
        let url = `${constants.API_URL}/api/product/get-list-of-product`
        const response = await http.post(url, obj)
        response.data.forEach(item => {
          item.approve = (item.status === 'APPROVED')
          item.reject = (item.status === 'REJECTED')
        })
        this.pendingProductList = response.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    changeStatus: async function () {
      let ref = this
      this.$dialog.info({
        title: 'Update Product Retailer Margin',
        text: 'Do you really want to <b>Update</b> this changes?',
        actions: {
          false: {
            text: 'No',
            handle: () => {
              return true
            }
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              try {
                let unCheckedProduct = []
                this.pendingProductList.forEach(item => {
                  if (!item.approve && !item.reject) {
                    unCheckedProduct.push(item.id)
                  }
                })
                if (unCheckedProduct.length > 0) {
                  return this.errMsg('Please checked all product before proceed to save.')
                }
                ref.isLoading = true
                let payload = {
                  refId: this.refrenceID,
                  approve: this.approveArray,
                  reject: this.rejectArray
                }
                let res = await http.put(`${constants.API_URL}/api/product/approved-reject-product`, payload)
                if (res.status === 200) {
                  ref.getProductList()
                  ref.isLoading = false
                  ref.dialog = false
                  ref.$dialog.notify.info('Status updated Successfully', {
                    position: 'top-right',
                    color: 'success',
                    timeout: 4000
                  })
                } else {
                  ref.isLoading = false
                  ref.dialog = false
                  ref.$dialog.notify.info('Failed to update status.', {
                    position: 'top-right',
                    color: 'error',
                    timeout: 4000
                  })
                }
              } catch (e) {
                ref.isLoading = false
                ref.dialog = false
                const errorMessage = (e && e.response && e.response.data.message) ? e.response.data.message : e.message
                ref.$dialog.notify.info(errorMessage, {
                  position: 'top-right',
                  color: 'error',
                  timeout: 4000
                })
              }
              return true
            }
          }
        }
      })
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    openTable () {
      this.dialog = true
      this.getPendingProductList()
    },
    selectSingleCheckBox (type, id, checkBoxValue) {
      if (type === 'approve') {
        this.checkItemHavingApproveFalse = []
        if (!checkBoxValue) {
          if (this.approveArray.indexOf(id) > -1) {
            this.approveArray.splice(this.approveArray.indexOf(id), 1)
          }
        } else {
          if (this.approveArray.indexOf(id) === -1) {
            this.approveArray.push(id)
          }
          if (this.rejectArray.indexOf(id) > -1) {
            this.rejectArray.splice(this.rejectArray.indexOf(id), 1)
            this.setApproveRejectCheckBoxFlag(type, id)
          }
        }
      } else {
        this.checkItemHavingRejectFalse = []
        if (!checkBoxValue) {
          if (this.rejectArray.indexOf(id) > -1) {
            this.rejectArray.splice(this.rejectArray.indexOf(id), 1)
          }
        } else {
          if (this.rejectArray.indexOf(id) === -1) {
            this.rejectArray.push(id)
          }
          if (this.approveArray.indexOf(id) > -1) {
            this.approveArray.splice(this.approveArray.indexOf(id), 1)
            this.setApproveRejectCheckBoxFlag(type, id)
          }
        }
      }
      this.handleCheckBoxFlagOnBehalfOfCondition()
    },
    handleCheckBoxFlagOnBehalfOfCondition: function (type) {
      this.approveFlag = true
      this.rejectFlag = true
      this.pendingProductList.forEach(item => {
        if (!item.approve && this.approveFlag) {
          this.approveFlag = false
        }
        if (!item.reject && this.rejectFlag) {
          this.rejectFlag = false
        }
      })
      if (!this.approveFlag) {
        this.approveHeaderFlag = false
      } else {
        this.approveHeaderFlag = true
      }
      if (!this.rejectFlag) {
        this.rejectHeaderFlag = false
      } else {
        this.rejectHeaderFlag = true
      }
    },
    getUniqueRefrenceProductListOnFilterBasis: async function () {
      try {
        let payload = {}
        payload.createdBy = this.selectedCreatedby
        payload.status = this.selectedStatus
        payload.createdAt = this.createdAtFilter
        const res = await http.post(
          `${constants.API_URL}/api/product/list-of-product-retailer-margin`,
          payload
        )
        if (res.status === 200) {
          this.refrenceProductData = res.data
        }
      } catch (e) {
        const errorMessage = (e.response && e.response.data) ? e.response.data.message : e.message
        this.errMsg(errorMessage)
      }
    },
    resetApplyFilter: function () {
      this.selectedCreatedby = ''
      this.selectedStatus = []
      this.createdAtFilter = ''
      this.getProductList()
    }
  }
}
</script>
<style>
.custom-header-wrapper>.custom-arrow-icon {
  visibility: hidden;
  /* Hide the arrow icon by default */
}

.custom-header-wrapper:hover>.custom-arrow-icon {
  visibility: visible;
  /* Show the arrow icon on hover */
  cursor: pointer;
}
</style>
